<template>
  <div class="opening shadow100">
    <img src="@/assets/img/vaccine.svg" alt="Vaccine" />

    <!-- Locked vaccine -->
    <div v-if="vaccineStatus === 'Locked'" class="center">
      <h2>Vaccine “Spizer”</h2>
      <p>
        Your neighbor, Neil Dijon Tyson, figured out how to make a vaccine for
        the virus during a long bathroom break. He just needs a "little"
        investment.
      </p>

      <ButtonChip
        :price="vaccinePrice"
        :buy="true"
        :item="'Vaccine'"
        action="UnlockVaccine"
        @event="changeStatus('Started')"
        >INVEST</ButtonChip
      >
    </div>
    <!-- Vaccine Devlopment Started -->
    <div v-show="vaccineStatus === 'Started'" class="center">
      <h2>Development in Progress</h2>

      <p>
        The famous billionaire Chill Cakes heard about the vaccine and promised,
        in case of success to invest in you 10 times more money than you have at
        the moment<br /><br />
        Use this time to earn money as more as you can, all your earnings will
        be multiplied x10.
      </p>

      <ProgressBar
        :time="devTime"
        :revenue="0"
        :progress="vaccineStatus === 'Started'"
        @finish="changeStatus('Finished')"
      />
    </div>

    <!-- Vaccine Devlopment Started -->
    <div v-show="vaccineStatus === 'Finished'" class="center">
      <h2>Vaccine Successfully Developed!</h2>

      <p>
        Sugar Sardine Yearning Tuna successfully developed and test vaccine in
        your city. <br /><br />
        Vaccine showing 140% effectiveness and a money-back guarantee! In 0.03
        cases, the patients developed unexplained cravings for basketballs.
      </p>

      <p class="body2">
        Chill Cakes kept his promise and invested in your bussiness
        {{ fVaccineReward }}
      </p>

      <div class="button" @click="changeStatus('Unlocked')">
        Save the World!
      </div>
    </div>
  </div>
</template>

<script>
import ButtonChip from "@/components/ButtonChip.vue";
import ProgressBar from "@/components/ProgressBar.vue";

export default {
  name: "Production",
  components: { ButtonChip, ProgressBar },
  props: {},

  data() {
    return {
      vaccinePrice: 1000000,
      vaccineStarted: false,
      vaccineReward: 0,
    };
  },

  computed: {
    prodItems: function() {
      return this.$store.state.prodItems;
    },

    vaccineStatus: function() {
      return this.$store.state.vaccineStatus;
    },

    fVaccineReward: function() {
      return this.vaccineReward
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    devTime: function() {
      return this.$store.state.vaccineDevTime / this.$store.state.timeMulti;
    },
  },

  mounted: function() {},

  methods: {
    click: function() {},
    changeStatus: function(status) {
      setTimeout(() => {
        this.vaccineStarted = true;
      }, 1);

      this.$store.commit("setVaccineStatus", status);

      if (status === "Finished") {
        this.vaccineReward = this.$store.state.money * 10;
        this.$store.commit("addMoney", this.vaccineReward);

        this.track(
          "Vaccine Developed",
          "Vaccine Developed",
          "Vaccine money: " + this.$store.state.money
        );
        // this.$store.commit("multiply", 10);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/vars.scss";
.tabMedicine {
  .opening {
    position: relative;
    margin: 16px;
    margin-top: 40px;
    background: #fff;
    border-radius: 24px;
    padding: 16px;
    text-align: center;
    top: 16px;

    h2 {
      margin-bottom: 0;
    }

    p {
      line-height: 1.5;
    }
  }
}
</style>
